<nav class="h-[65px] bg-gray-100 sticky top-0 border-b border-gray-200 shadow-md px-6 z-10">
  <div class="w-full h-full flex items-center justify-end">
    <div class="flex items-center gap-6">
          <p-avatar
            [image]="user()?.photoUrl || undefined"
            [label]="!user()?.photoUrl ? getInitials(user()?.name) : ''"
            shape="circle"
            size="large"
            [style]="!user()?.photoUrl ? {'background-color': getRandomBg(), 'color': '#ffffff', 'font-size': '14px'} : {}"
            styleClass="cursor-pointer shadow-sm border border-gray-200 transition-transform hover:scale-105">
          </p-avatar>
    </div>
  </div>
</nav>
